import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import SalesInfo from "./salesInfo";
import { useNavigate } from "react-router-dom";
import Logo from "../../../../../assets/images/Girlush Logo.png"
import { Helmet } from "react-helmet-async";
import axios from "axios";

const SalesReorder = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const codeRef = useRef(null)
  const [isFull, setIsFull] = useState(false);
  const [data, setData] = useState([])
  const [docName, setDocName] = useState('')
  const [code,setCode] = useState('')
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [supplierData, setSupplierData] = useState([]);
     const [allSubData, setAllSubData] = useState([]);
          const [orderDetails1, setOrderDetails] = useState(data);
    
      const [catData,setCatData] = useState([])
      const [subData,setSubData] = useState([])
        const [options, setOptions] = useState({
          customer : null,
          category : null,
          subCategory : null
      })
  const outletId = localStorage.getItem("outlet_id")


  const navigate = useNavigate()
  const[postData , setPostData] = useState({
    wh_id:0,
      docdate: "", 
      amount: "",
      // subtotal_amount: "",
      // gst_per: 0,
      gst_amt: "",
      // cess_per: 0,
      // cess_amt: "",
      // roff: "",
      // mode:"",
      // company_id: 1,
      // is_individual : 1,
  
      total_qty: "",
      total_items:0,
      packing_details: [],
      // cat_id:0,

      // head_id:0,
      // type_design_id:0,
      // uom_id:0,
  })

  const toggleFullscreen = () => {
   const isFullScreen = document.fullscreenElement
if(isFullScreen){
  document.exitFullscreen()
  setIsFull(!isFull)
}
else{
  fullscreenRef.current.requestFullscreen();
  setIsFull(!isFull)
}
  };
  
  useEffect(() => {
    const checkFullscreen = () => {
      const isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
      setIsFull(!!isFullScreen);
    };
  
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        checkFullscreen();
      }
    };
  
    document.addEventListener('fullscreenchange', checkFullscreen);
    document.addEventListener('mozfullscreenchange', checkFullscreen);
    document.addEventListener('webkitfullscreenchange', checkFullscreen);
    document.addEventListener('msfullscreenchange', checkFullscreen);
    document.addEventListener('keydown', handleEscapeKey);
  
    return () => {
      document.removeEventListener('fullscreenchange', checkFullscreen);
      document.removeEventListener('mozfullscreenchange', checkFullscreen);
      document.removeEventListener('webkitfullscreenchange', checkFullscreen);
      document.removeEventListener('msfullscreenchange', checkFullscreen);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [setIsFull]);

  
  console.log(postData,"ddddddd")
  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet><title>Indent</title></Helmet>
      <Grid className={classes.titleInfo} sx={{paddingBlock:"25px"}}>
        {/* {isFull ? <IconButton onClick={toggleFullscreen}><ZoomInMap /></IconButton>
         : <IconButton onClick={toggleFullscreen}><CropFree /></IconButton>} */}
         <Grid className="flex justify-between items-center">
          <Avatar variant="square" src={Logo} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",}}/>
          {/* <Typography  fontWeight={600} ml={1} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",fontSize:20}}>GIRLUSH</Typography> */}
        </Grid>
        <Typography variant="h5" fontWeight={600}>Indent</Typography>
        <Typography>Press F11 to Full Screen </Typography>
      </Grid>
      <Grid className={classes.contentGrid}>
        {/* <Grid className="w-5/6" sx={{display: 'flex', flexDirection:'column',  flex: 1,}}>
          <Grid className="border-b" sx={{height:'fit-content'}}><SalesInfo setPostData={setPostData}  postData={postData} docName={docName} setDocName={setDocName}/></Grid>
          <Grid className="p-2 " sx={{flex:1, height:'100%',maxHeight:"80%" , overflow:"auto"}}><BillingTable data={data} setData={setData} code={code} setCode={setCode} ref={codeRef} setPostData={setPostData} postData={postData}/></Grid>
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo data={data} setData={setData} postData={postData} setPostData={setPostData} docName={docName}/>
          </Grid>
         
        </Grid> */}
          <Grid
          className="w-5/6"
          sx={{ display: "flex", flexDirection: "column", flex: 1 ,height: "calc(100% - 40px)",}}
        >
          <Grid className="border-b" sx={{ height: "fit-content" }}>
              <SalesInfo data={data} setPostData={setPostData}  postData={postData} docName={docName} setDocName={setDocName} 
                    catData={catData} setCatData={setCatData} subData={subData} setSubData ={setSubData}
          allSubData={allSubData} setAllSubData={setAllSubData} options={options} setOptions={setOptions} 
              />
          </Grid>
          <Grid className="p-2 " sx={{flex:1}}>
          <BillingTable data={data} setData={setData} code={code} setCode={setCode} ref={codeRef} setPostData={setPostData} postData={postData} docName={docName}
          catData={catData} setCatData={setCatData} subData={subData} setSubData ={setSubData}
          allSubData={allSubData} setAllSubData={setAllSubData} options={options} setOptions={setOptions} 
          orderDetails1={orderDetails1} setOrderDetails={setOrderDetails}
          />
          </Grid>
        
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
              <CustomerInfo orderDetails1={orderDetails1} setOrderDetails={setOrderDetails} data={data} setData={setData} postData={postData} setPostData={setPostData} docName={docName} outletId={outletId} setDocName={setDocName} options={options} setOptions={setOptions} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SalesReorder;
